import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    OnInit,
    EventEmitter,
    IterableDiffers,
    Component,
    Input,
    Output
} from '@angular/core';
import {Router} from '@angular/router';
import {StateService} from 'src/app/core/services/state/state.service';
import {TranslateService} from '@ngx-translate/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ComponentSidebar} from 'src/app/shared/classes/components/component_sidebar';

@Component({
    selector: 'app-right-matches-selected-items',
    templateUrl: './right-matches-selected-items.component.html',
    styleUrls: ['./right-matches-selected-items.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RightMatchesSelectedItemsComponent extends ComponentSidebar implements OnInit {

    @Input() width = '';

    @Output() removeElmt = new EventEmitter();
    @Output() actionOnRecords = new EventEmitter();

    action: any;
    iterableDiffer: any;
    maxPerPage = 30; /** mod this */

    constructor(private _iterableDiffers: IterableDiffers,
                private changeDetectorRef: ChangeDetectorRef,
                public translateService: TranslateService,
                protected stateService: StateService,
                protected deviceService: DeviceDetectorService,
                protected router: Router) {
        super(stateService, translateService, router, deviceService);
        this.iterableDiffer = this._iterableDiffers.find([]).create(null);
    }

    ngOnInit() {
        this.stateService[this.specificState()].multiselectWatch$.subscribe(
            res => {
                if (res) {
                    this.selectedItems = this.stateService[this.specificState()].multiselect;
                    this.updateList(this.selectedItems, this.maxPerPage);
                    this.changeDetectorRef.markForCheck();
                }
            }
        );
    }

    act() {
        if (this.action) {
            let event = {
                actionType: this.action,
                ids: []
            };
            for (let item of this.selectedItems) {
                event.ids.push(item.id);
            }

            this.actionOnRecords.emit(event);
        }
    }

    removeItem(item) {
        this.state.multiselect.splice(
            this.selectedItems.indexOf(item),
            1
        );
        this.selectedItems = this.state.multiselect;
        this.state.multiselectWatch.next(true);

        this.changeDetectorRef.markForCheck();
    }

    onResize(event) {
        // this.informationVisibility = (event.target.innerHeight < 725);
    }

}

